import { render } from "./App.vue?vue&type=template&id=cbd0c17e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cbd0c17e&lang=css"

import exportComponent from "D:\\世通软件\\official-website-code-base\\st_html5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__